import { useTheme } from '@mui/material/styles';
import { useRoutes } from 'react-router-dom';
import BrandBillingGuard from './components/brand-billing-guard/brand-billing-guard';

const MainPage = ({ isDesktop = true, pathname, routes, isShowOfferBanner = false }) => {
  const element = useRoutes(routes);
  const theme = useTheme();
  let currentRoute = routes.find(route => route.path === pathname?.replace("/", ""));
  let isChildRoute = false;
  if (currentRoute) {
    isChildRoute = currentRoute.element?.props?.permissions ? true : false;
  }
  return (
    <div
      style={{
        ...(isChildRoute
          ? {
            flexGrow: 1,
            minHeight: '100%',
            padding: isDesktop && theme.spacing(2),
            position: 'relative',
            top: '64px',
            width: isDesktop ? 'calc(100vw - 352px)' : '100%',
            height: !isDesktop ? 'calc(100vh - 133px)' : '100%',
            overflow: 'auto',
            // Long pages must fit below the fixed header so their scroll bottom stays visible.
            ...((pathname === '/competitors' && isDesktop) || pathname?.startsWith('/ai-connections') ? {
              minHeight: 0,
              height: `calc(100dvh - ${(isDesktop ? 64 : 133) + (isShowOfferBanner ? 50 : 0)}px)`,
              boxSizing: 'border-box',
              paddingBottom: `calc(${theme.spacing(4)} + env(safe-area-inset-bottom, 0px))`,
            } : {}),
          }
          : {})
      }}
    >
      <BrandBillingGuard>{element}</BrandBillingGuard>
    </div>
  );
};

export default MainPage;
